export const WARNING_TIMEOUT = 30 * 60 * 1000 // 30 minutes
export const IDLE_TIMEOUT = 31 * 60 * 1000 // 31 minutes
